// src/utils/analytics.js
// Thin wrapper around Plausible Analytics.
//
// Set VITE_PLAUSIBLE_DOMAIN to your production domain (e.g. "orbitapp.io") to
// enable tracking. Leave it unset in development — no script is injected and
// trackEvent() is a no-op.
//
// Usage:
//   import { trackEvent } from '../utils/analytics';
//   trackEvent('Onboarding Completed');
//   trackEvent('Calendar Connected', { provider: 'google' });

const DOMAIN = import.meta.env.VITE_PLAUSIBLE_DOMAIN;

let injected = false;

export function initAnalytics() {
  if (!DOMAIN || injected || typeof document === 'undefined') return;
  injected = true;

  const script = document.createElement('script');
  script.defer = true;
  script.dataset.domain = DOMAIN;
  script.src = 'https://plausible.io/js/script.js';
  document.head.appendChild(script);
}

/**
 * Fire a custom Plausible event. No-op if Plausible is not loaded.
 * @param {string} name  Event name shown in the Plausible dashboard
 * @param {Record<string,string|number>} [props]  Custom properties (optional)
 */
export function trackEvent(name, props) {
  if (typeof window === 'undefined') return;
  if (typeof window.plausible !== 'function') return;
  window.plausible(name, props ? { props } : undefined);
}
